import { createMuiTheme } from '@material-ui/core/styles'

// 4KST Blue - #72C9FC

export default createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      light: '#FF617A',
      main: '#FF617A',
      dark: '#BF495A',
      contrastText: '#FFF'
    },
    secondary: {
      light: '#363636',
      main: '#363636',
      dark: '#BF495A',
      contrastText: '#FFF'
    },
    background: {
      default: '#DADADA',
      black: '#292929',
      shade01: '#F7F7F7',
      shade02: '#363636',
      startScreen: '#DADADA'
    },
    textColor: {
      caption: '#363636',
      main: '#292929'
    },
    action: {
      disabled: '#363636'
    }
  }
})